import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { clearAuthToken, login, tokenExists } from '../api/auth';
import { clearClientPortalToken, loginClientPortal, setClientPortalToken } from '../api/clientPortalApi';
import { setCookie } from '../utils/cookies';

const isValidEmail = (value) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(value || '').trim());

const formatRut = (value) =>
  String(value || '')
    .replace(/[^0-9kK]/g, '')
    .replace(/^(\d{1,2})(\d{3})(\d{3})([0-9kK])$/, '$1.$2.$3-$4')
    .toUpperCase();

const isRutLike = (value) => /^[0-9.\-kK\s]+$/.test(String(value || '').trim());

const LoginPage = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  if (tokenExists()) return <Navigate to="/home" replace />;

  const handleLogin = async (e) => {
    e.preventDefault();
    const trimmedIdentifier = identifier.trim();
    setMessage('');
    setLoading(true);
    try {
      if (isValidEmail(trimmedIdentifier)) {
        clearClientPortalToken();
        const { token } = await login(trimmedIdentifier, password);
        setCookie('token', token, 2);
        window.location.href = '/home';
        return;
      }

      clearAuthToken();
      const response = await loginClientPortal({ rut: trimmedIdentifier, password });
      setClientPortalToken(response.token);
      window.location.href = response?.client?.mustChangePassword
        ? '/client-portal/change-password'
        : '/client-portal/request';
    } catch (error) {
      setMessage(error?.response?.data?.message || error.message || 'Credenciales inválidas.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">Inicio de Sesión</h1>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="text"
            placeholder="RUT o correo"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            onBlur={() => {
              if (!isValidEmail(identifier) && isRutLike(identifier)) setIdentifier(formatRut(identifier));
            }}
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition duration-200 disabled:opacity-60"
          >
            {loading ? 'Ingresando...' : 'Iniciar Sesión'}
          </button>
        </form>
        <Link to="/display" className="block mt-6 text-center font-semibold text-green-800 underline underline-offset-4">Pantallas de destacados →</Link>
        {message && (
          <p className="mt-4 text-center font-semibold text-red-500">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
